import { getKvSyncApi } from '@/api/kvSync'
import Socket from '@/socket'
import slide from '@/api/slide'
import sentry from '@/services/sentry'

const actions = {
  fallbackNextBackToAhaSync: async ({ rootState }) => {
    try {
      const resp = await getKvSyncApi().getValueByKey(`/activeSlide/${rootState.presentation.id}`)
      if (resp.body && resp.body.value) {
        const value = JSON.parse(resp.body.value)
        if (value.id === rootState.presentation.activeSlide) {
          return
        }
      }
      const payload = {
        activeSlide: rootState.presentation.activeSlide,
        socketId: Socket.getSocketId(),
        accessCode: rootState.presentation.uniqueAccessCode,
        isNextSlide: true,
        timestamp: new Date().getTime(),
        id: rootState.presentation.activeSlide,
      }
      slide.syncActiveSlideState(rootState.presentation.id, payload)
    } catch (error) {
      sentry.captureException(error)
    }
  },
}

export default {
  namespaced: true,
  actions,
}
